import React from 'react'

export default function Component_Heading(props) {
  return (
    <>
      <div className="client-main1">
      <div className="client-heading">
        <h1>{props.heading}
        </h1>
      </div>
      <div className="client-para">
        <p>{props.para}</p>
      </div>
      </div>
    </>
  )
}
